import { formatarAteDuasCasas } from '@/lib/formato';

/**
 * OS LITROS DE UM LANÇAMENTO, com as casas que eles têm: `320`, `88,5`, `1,5`.
 *
 * A coluna gravada é `numeric` com casas, e o celular lança 1,5 L de verdade
 * (ARLA, um complemento). Escrito como inteiro, 1,5 L aparecia na mesa como
 * "2 L" (robôs no QAS, 20/10/2026) — um litro e meio que não aconteceu, na
 * linha que alguém confere contra o cupom. A soma da tabela usa o mesmo
 * formato, senão ela discordaria das próprias linhas.
 */
export function litrosEscritos(litros: number): string {
  return formatarAteDuasCasas(litros);
}
